import { uiEvents } from '@/utils/event'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { ReactNode } from 'react'

export function MuiCheckbox(props: {
  id: string
  label: ReactNode
  value: boolean
  checkboxProps?: CheckboxProps
  disabled?: boolean
}) {
  return (
    <FormControlLabel
      onChange={() => {
        uiEvents.next({
          type: 'CheckboxToggle',
          id: props.id,
        })
      }}
      control={
        <Checkbox {...props.checkboxProps} disabled={props.disabled} checked={props.value} />
      }
      label={props.label}
    />
  )
}
